import { Component, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() color: string;
  @Input() icon: string;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    //to add new icon path just add new .addSvgIcon()
    this.matIconRegistry.addSvgIcon(
      `circle-info`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../assets/images/circle-info.svg'
      )
    );
  }
}
